// ── BusinessInfoModal — 발주서 사업자 정보 입력 ──────────────
// 사업자명 / 사업자등록번호 / 대표자 / 연락처 / 주소
// localStorage 'ddabak_biz_info' (JSON)에 저장. 발주서 헤더와 출력에 사용.
import React, { useState, useEffect } from 'react';

export default function BusinessInfoModal({ open, initialInfo = {}, onSave, onClose }) {
  const [draft, setDraft] = useState({
    name: '', regNum: '', ceo: '', phone: '', address: '',
  });

  useEffect(() => {
    if (open) {
      setDraft({
        name: initialInfo.name || '',
        regNum: initialInfo.regNum || '',
        ceo: initialInfo.ceo || '',
        phone: initialInfo.phone || '',
        address: initialInfo.address || '',
      });
    }
  }, [open, initialInfo]);

  if (!open) return null;

  const handleSave = () => {
    onSave({ ...draft });
    onClose();
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', border: '1.5px solid #e5e7eb',
    borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box',
  };
  const labelStyle = {
    fontSize: 12, fontWeight: 700, color: '#6b7280', marginBottom: 6, display: 'block',
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 16, width: 480, maxWidth: '95vw',
        maxHeight: '90vh', overflowY: 'auto', padding: 24,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }} onClick={e => e.stopPropagation()}>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
          <h2 style={{ fontSize: 18, fontWeight: 800, color: '#18181B', margin: 0 }}>
            📋 사업자 정보
          </h2>
          <button onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#9ca3af' }}>
            ✕
          </button>
        </div>

        <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 18, lineHeight: 1.6 }}>
          여기에 입력한 정보는 <strong>발주서 상단·인쇄·이메일 전송</strong>에 자동으로 표시돼요. 한 번만 입력하면 모든 발주서에 반영됩니다.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={labelStyle}>사업자명 (상호) *</label>
            <input value={draft.name}
              onChange={e => setDraft({ ...draft, name: e.target.value })}
              placeholder="예: 따박상회" style={inputStyle} />
          </div>

          <div>
            <label style={labelStyle}>사업자등록번호</label>
            <input value={draft.regNum}
              onChange={e => setDraft({ ...draft, regNum: e.target.value })}
              placeholder="예: 123-45-67890" style={inputStyle} />
          </div>

          <div>
            <label style={labelStyle}>대표자명</label>
            <input value={draft.ceo}
              onChange={e => setDraft({ ...draft, ceo: e.target.value })}
              placeholder="예: 김철수" style={inputStyle} />
          </div>

          <div>
            <label style={labelStyle}>연락처</label>
            <input value={draft.phone}
              onChange={e => setDraft({ ...draft, phone: e.target.value })}
              placeholder="예: 010-1234-5678" style={inputStyle} />
          </div>

          <div>
            <label style={labelStyle}>주소</label>
            <input value={draft.address}
              onChange={e => setDraft({ ...draft, address: e.target.value })}
              placeholder="예: 서울 강남구 ㅇㅇ로 1, 1층" style={inputStyle} />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 22 }}>
          <button onClick={onClose}
            style={{
              flex: 1, padding: '11px', borderRadius: 8,
              border: '1.5px solid #e5e7eb', background: '#fff',
              color: '#6b7280', fontSize: 14, fontWeight: 600, cursor: 'pointer',
            }}>취소</button>
          <button onClick={handleSave}
            style={{
              flex: 2, padding: '11px', borderRadius: 8, border: 'none',
              background: '#FF6F0F', color: '#fff', fontSize: 14, fontWeight: 800, cursor: 'pointer',
            }}>저장</button>
        </div>
      </div>
    </div>
  );
}
